import { createComponents, NO_PATTERN_BUSINESS_LOGIC, } from '@vfde-brix/ws10/core';
import { SYSTEM_ICON_BASE_CLASS } from './Constants';
import { createIcon } from './Icon';
createComponents(".".concat(SYSTEM_ICON_BASE_CLASS), createIcon, NO_PATTERN_BUSINESS_LOGIC);
